// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b585da08","879":"2dbc3e2e"}[chunkId] + ".chunk.js";
};